import {
  confirmKycAdminDevice as confirmDeviceKycApi,
  listDevicesAdminDevice as listUserDevicesApi,
} from '@api/generated/sdk.gen';

import type { AdminDeviceResponse } from '@api/generated/types.gen';

/**
 * Слой доступа к эндпоинтам админки по пользователям.
 *
 * Изолирует сгенерированные функции SDK, чьи имена выводятся из `operationId`
 * SpringDoc и нестабильны — добавление эндпоинта на бэке перенумеровывает их.
 * Остальной код фичи импортирует семантические обёртки отсюда, поэтому после
 * `npm run gen:api` правки нужны только в этом файле.
 *
 * Клиент настроен на `throwOnError: true` (см. `api/runtime-config.ts`), значит
 * на 4xx/5xx вызовы кидают axios-ошибку — её ловит `onError` в react-query.
 */

/**
 * Загружает все устройства пользователя, включая отозванные (свежие сверху).
 * `kycConfirmedAt == null` означает карантин: доступ с устройства ограничен,
 * пока личность не подтверждена. Требует право `users.read`.
 */
export async function fetchUserDevices(userId: string): Promise<AdminDeviceResponse[]> {
  const res = await listUserDevicesApi({ path: { userId } });
  return res.data ?? [];
}

/**
 * Снимает карантин с устройства вручную (override вместо liveness в MyID).
 * Причина обязательна — попадает в неизменяемый аудит
 * (`DEVICE / KYC_CONFIRM_OVERRIDE`). Бэк отвечает 204 без тела.
 * Требует право `users.manage`.
 */
export async function confirmDeviceKyc(
  userId: string,
  deviceId: string,
  reason: string,
): Promise<void> {
  await confirmDeviceKycApi({ path: { userId, deviceId }, body: { reason } });
}
